import { PendingIssueListView } from '@euler/app/flows/common/components/PendingIssueListView';
import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { Aside } from '@euler/components/Aside';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { adaptiveWrapperOptions } from '@euler/functions/navigationOptionsBuilder';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  isMobileLayout,
  useIsMobileLayout,
} from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const ServiceRecordPendingIssuesPage = wrapNavigatorScreen(
  () => {
    const { rpx } = useResponsiveContext();
    const { bottom } = useSafeAreaInsets();
    const isMobile = useIsMobileLayout();

    const {
      serviceRecord: { pendingIssuesV2 },
    } = useServiceRecordContext();

    if (isMobile) {
      return (
        <PendingIssueListView
          pendingIssues={pendingIssuesV2 ?? []}
          contentContainerStyle={{
            paddingBottom: bottom + rpx(15),
          }}
        />
      );
    }
    return (
      <Aside dismissible>
        <LayoutProviderView
          css={`
            flex: 1;
          `}
        >
          <PendingIssueListView
            pendingIssues={pendingIssuesV2 ?? []}
            contentContainerStyle={{
              paddingBottom: bottom + rpx(15),
            }}
          />
        </LayoutProviderView>
      </Aside>
    );
  },
  adaptiveWrapperOptions<any>(() => ({
    title: '遗留问题',
    headerStatusBarHeight: undefined,
    headerShown: isMobileLayout(),
  })),
);
